<template>
  <div
    v-if="loadThirparty"
    class="instagramFeed">
    <div v-if="active && accessToken"
      class="feeds"
      :style="feedGrid"
      :data-caption="item.detail.instagramfeed.caption">
      <div v-for="(feed, index) in feeds"
        :key="index"
        class="feedItem">
        <div v-if="feed.media_url" class="thumb" :style="feedThumbnail(feed)"></div>
        <div v-if="feed.caption" class="caption">{{ feed.caption }}</div>
      </div>
    </div>
    <div v-else class="message">
      <p v-if="active === false">{{locale.message_editor_inactive}}</p>
      <p v-else-if="accessToken === false">{{locale.message_editor_no_access_token}}</p>
      <p v-else>{{locale.message_generate_auth_code}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Instagramfeed',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  computed: {
    feeds () {
      const max = parseInt(this.item.detail.instagramfeed.items)
      return this.feedList && this.feedList.filter((x, i) => i < max)
    },
    feedGrid () {
      const cols = this.item.detail.instagramfeed.cols
      const margin = this.item.detail.instagramfeed.margin
      return {
        'grid-template-columns': `repeat(${cols}, 1fr)`,
        'row-gap': `${margin}px`,
        'column-gap': `${margin}px`
      }
    }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      loadThirparty: false,
      active: null,
      accessToken: null,
      feedList: null
    }
  },
  methods: {
    init () {
      this.$store.dispatch('thirdparty/getThirdparty').then((res) => {
        const instagram = res && res.find(x => x.id === 'instagramfeed')
        const active = instagram && instagram.active
        this.loadThirparty = true
        this.active = active
        if (active) {
          this.$store.dispatch('thirdparty/getAccessToken', { sns: 'instagram' }).then((result) => {
            const accessToken = result && result.access_token
            if (accessToken) {
              this.accessToken = accessToken
              this.$store.dispatch('thirdparty/getInstagramFeed', { accessToken: accessToken }).then((media) => {
                this.feedList = media.data
              })
            }
          })
        }
      })
    },
    feedThumbnail (feed) {
      const isVideo = feed.media_type === 'VIDEO'
      const thumb = isVideo ? feed.thumbnail_url : feed.media_url
      return {
        background: thumb ? `url("${thumb}") 50% 50% / cover no-repeat` : null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  font-size: 14px;
  color: $color-red;
}
</style>
